/**
 *获得环境变量
 */
export function getENV() {
  let host = url('hostname')
  return appConfig.env[host] ? appConfig.env[host] : appConfig.env['localhost']
}

/**
 * 时间日期格式化
 * @param time
 * @param str
 * @returns {*}
 */
export const timeFormat = (time, str) => {
  const handlerZero = (value) => {
    return value < 10 ? '0' + value : value;
  };
  const dateObj = new Date(time);
  const Y = dateObj.getFullYear();
  const m = handlerZero(dateObj.getMonth() + 1);
  const d = handlerZero(dateObj.getDate());
  const W = dateObj.getDay();
  const H = handlerZero(dateObj.getHours());
  const M = handlerZero(dateObj.getMinutes());
  const S = handlerZero(dateObj.getSeconds());

  const ruleArr = [
    {regx: new RegExp('%' + 'Y', 'g'), value: Y},
    {regx: new RegExp('%' + 'm', 'g'), value: m},
    {regx: new RegExp('%' + 'd', 'g'), value: d},
    {regx: new RegExp('%' + 'H', 'g'), value: H},
    {regx: new RegExp('%' + 'M', 'g'), value: M},
    {regx: new RegExp('%' + 'S', 'g'), value: S},
    {regx: new RegExp('%' + 'W', 'g'), value: ['日', '一', '二', '三', '四', '五', '六'][W]}
  ];

  ruleArr.forEach(r => {
    str = str.replace(r.regx, r.value);
  });

  return str;
};

/**
 * 获得js数据类型
 * @param data
 * @returns {string}
 */
export function getJsDataType(data) {
  let type = Object.prototype.toString.call(data);
  type = type.toLowerCase();
  return type.replace(/\[object\s|\]/g, '');
}

/**
 * 空值判断
 * @param data
 * @returns {boolean}
 */
export function isEmpty(data) {
  const type = getJsDataType(data);
  let ret;
  switch (type) {
    case 'number':
      ret = data === 0;
      break;
    case 'array':
      ret = data.length === 0;
      break;
    case 'object':
      ret = Object.keys(data).length === 0;
      break;
    case 'string':
      data = data.replace(/\s/g, '');
      if (data === 'null' || data === 'undefined' || data === '0') ret = true;
      else ret = data.length === 0;
      break;
    case 'null':
    case 'undefined':
      ret = true;
      break;
    default:
      ret = false;
  }
  return ret;
}

/**
 * 两位小数计算
 * @param r
 */
export function formatFloat(r) {
  r = parseFloat(r);
  r = r.toFixed(2);
  return parseFloat(r);
}

/**
 * 获得按钮组
 * @param arr
 * @param map
 * @param type
 * @returns {*}
 */
export function commonGetBtns(arr, map, type = 'object') {
  return arr.map(r => {
    let data = null;
    if (type === 'object') {
      data = map[r];
    } else if (type === 'array') {
      data = map.find(rr => rr.name === r);
    }
    return {
      name: r,
      ...data
    }
  })
}

/**
 * 对象提取
 * @param object
 * @param arr
 */
export function pickByArray(object, arr) {
  let ret = {};
  arr.forEach(r => {
    ret[r] = object[r] || null;
  });
  return ret;
}

/**
 * 对象提取
 * @param object
 * @param map
 */
export function pickByObject(object, map) {
  let ret = {};
  for (let key in map) {
    ret[key] = object[map[key]] || null;
  }
  return ret;
}

/**
 * 获得阿里云直播过期时间戳
 * @param timeLength
 * @returns {number}
 */
export function getAliCloudLiveTime(timeLength) {
  return Math.floor((timeLength + new Date().getTime()) / 1000);
}

/**
 * 生成阿里云直播鉴权URL
 * @param path
 * @param time
 * @param key
 * @returns {string}
 */
export const makeAliCloudLiveAuthKey = (path, time, key, suffix = '') => {
  path = path + suffix;
  let str = `${path}-${time}-0-0-${key}`;
  let hash = hex_md5(str);
  return `${path}?auth_key=${time}-0-0-${hash}`;
};

/**
 *
 * @param streamName
 * @param time
 * @param key
 * @returns {string}
 */
export const makeTxCloudLiveAuthKey = (streamName, time, key) => {
  //十六进制转化
  time = time.toString(16);
  const txSecret = hex_md5(`${key}${streamName}${time}`);
  return `?txSecret=${txSecret}&txTime=${time}`
};

/**
 * 生成URL
 * @param options
 * @returns {string}
 */
export function makeURL(options) {
  let url = ''
  if (options.protocol) {
    url += options.protocol + '://'
  }
  if (options.hostname) {
    url += options.hostname
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ':' + options.port
  }
  if (options.path) {
    url += options.path
  }
  if (options.query) {
    let q = ''
    for (let key in options.query) {
      if (options.query[key]) {
        q += `&${key}=${options.query[key]}`
      } else {
        q += `&${key}`
      }
    }
    q = q.substr(1)
    url += '?' + q
  }
  if (options.hash) {
    url += '#' + options.hash
  }
  return url
}

/**
 * 解析url参数
 * @param from
 * @returns {{path: (*|{}), protocol: (*|{}), hostname: (*|{}), port: (*|{}), query: (*|{}), hash: (*|{})}}
 */
export function analyzeURL(from) {
  let protocol = url('protocol', from)
  let hostname = url('hostname', from)
  let port = url('port', from)
  let path = url('path', from)
  let query = url('?', from)
  let hash = url('hash', from)
  return {protocol, hostname, port, path, query, hash}
}


/**
 *  返回元素在数组中出现的次数
 *
 */
export function isContains(arrays, item) {
  let count = 0;
  for (let o in arrays) {
    if (arrays[o] == item) {
      count++;
    }
  }
  return count > 1 ? true : false
}
